// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3h8dD","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3GQQT","obliqueLine":"membershipbadge_obliqueLine__1slFl"};